import React from 'react';

const CATS = [
  { c: 'c-4', title: 'Frontend', items: ['React','JS / JSX','HTML · CSS','Tailwind','Redux','Expo','Electron'] },
  { c: 'c-4', title: 'Backend',  items: ['Java','C / C++','Node.js','Express','Python','COBOL'] },
  { c: 'c-4', title: 'Database', items: ['MongoDB','PostgreSQL','MySQL','Prisma','Supabase'] },
  { c: 'c-6', title: 'Tools & Craft',      items: ['Git','VIM <3','VSCode','Figma','Framer','Blender','OpenGL'] },
  { c: 'c-6', title: 'Offensive Security', items: ['BurpSuite','NMAP','SqlMap','GoBuster','LinPeas','Hydra','WireShark','Metasploit','Hashcat','OWASP','Netcat'] },
];

export default function Skills() {
  return (
    <section id="skills">
      <div className="container-x">
        <header className="section-head">
          <h2 data-reveal="">The kit I reach for, <em>depending on the problem.</em></h2>
        </header>
        <div className="skills-grid" data-reveal="">
          {CATS.map((cat) => (
            <div key={cat.title} className={`skill-cell ${cat.c}`}>
              <div className="head"><h3>{cat.title}</h3></div>
              <div className="skill-items">{cat.items.map(s => <span key={s}>{s}</span>)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
